import React from 'react';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { DeviationDuperbrowseContext } from '../../../Duperbrowse';
import { MeasuredCookieType } from '../../../Measured';
import MeasuredDeviationsMosaic from '../../../MeasuredDeviationsMosaic';
const MOSAIC_HEIGHT = 289; // 321 - 2 * 16 because the measured mosaic has paddings removed
const DeviationSidebarMosaic = ({ streamId , deviations , parentDeviation , className  })=>{
    const preloadEnabled = false;
    return /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        preloadEnabled: preloadEnabled,
        streamId: streamId,
        deviations: deviations,
        parent: {
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId
        }
    }, /*#__PURE__*/ React.createElement(MeasuredDeviationsMosaic, {
        deviations: deviations.slice(0, 3),
        height: MOSAIC_HEIGHT,
        cookieType: MeasuredCookieType.DEVIATION_MOBILE_SIDEBAR,
        className: className
    }));
};
DeviationSidebarMosaic.displayName = 'DeviationSidebarMosaic';
export default DeviationSidebarMosaic;
